export default (state, scopedGuestlists) => {
  state.scopedGuestlists = scopedGuestlists;
}



// WEBPACK FOOTER //
// ./src/app/store/templates/main/mutations/set-scoped-guestlists.js